// party.ui.client.tsx - Party coordination UI component
// Displays party panel on main screen with join code, member list, and ready-up system

import { useGameState } from "@game/state";
import { Panel } from "./Panel";
import { showSuccessToast } from "./toasts";
import { uiBridge } from "./ui.bridge";

export const PartyPanel = () => {
  const { party, playerId } = useGameState((state) => ({
    party: state.party,
    playerId: state.playerId,
  }));

  if (!party) {
    return (
      <Panel title="SQUADRON">
        <p className="party-loading">INITIALIZING SQUADRON SYSTEM...</p>
      </Panel>
    );
  }

  return (
    <Panel title={`SQUADRON [${party.members.length}/16]`}>
      {party.members.length > 1 && (
        <button
          type="button"
          className="squadron-close-button"
          onClick={() => {
            uiBridge.sendMessage({ t: "party_leave" });
          }}
          title="Leave squadron"
        >
          X
        </button>
      )}

      <button
        type="button"
        className="party-invite-button"
        onClick={() => {
          navigator.clipboard.writeText(
            `${window.location.origin}/?party=${party.joinCode}`,
          );
          showSuccessToast("Copied to clipboard", 2000);
        }}
      >
        <div className="invite-action">
          <span className="copy-icon">⎘</span>
          <span className="invite-label">INVITE FRIENDS</span>
        </div>
        <span className="invite-url">
          {`${window.location.origin}/?party=${party.joinCode}`}
        </span>
      </button>

      <div className="party-members">
        {party.members.map((member) => (
          <div key={member.id} className="member">
            <div className="member-info">
              {member.id === party.leader && (
                <span className="leader-badge" title="Squadron Leader">
                  ★
                </span>
              )}
              <span className="member-name">{member.name}</span>
              {member.steamId && (
                <span className="steam-badge" title="Steam User">
                  🎮
                </span>
              )}
            </div>
            <button
              type="button"
              className={`member-ready-button ${member.ready ? "ready" : "not-ready"} ${member.id === playerId ? "is-current-player" : "is-other-player"}`}
              onClick={() => {
                if (member.id === playerId) {
                  uiBridge.sendMessage({ t: "party_toggle_ready" });
                }
              }}
              disabled={member.id !== playerId}
            >
              {member.id === playerId
                ? member.ready
                  ? "READY"
                  : "READY UP"
                : member.ready
                  ? "READY"
                  : "NOT READY"}
            </button>
          </div>
        ))}
      </div>
    </Panel>
  );
};
